
export default () => {

  const mobileMenu = document.getElementById('mobile-menu');

  document.getElementById('mobile-button').addEventListener('click', function() {
    mobileMenu.classList.add("visible")
  }, false);

  document.getElementById('mobile-close').addEventListener('click', function() {
    mobileMenu.classList.remove("visible")
  }, false);
}

